import { type RepubCountry } from '@cx-web/domain-types';
import { format, isToday, parseISO } from 'date-fns';
import { enGB, enUS, it } from 'date-fns/locale';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

const localeTimeMap = {
  uk: enGB,
  it: it,
  us: enUS,
};

export const transformFieldLabel = (
  { label }: RefinementListItem,
  lng?: { repubCountry: RepubCountry; today: string },
) => {
  const locale = (lng?.repubCountry && localeTimeMap[lng.repubCountry]) || enGB;

  const isIsoDateString = /^\d{4}-\d{2}-\d{2}$/.test(label);

  if (isIsoDateString) {
    const localDate = parseISO(label);

    if (isToday(localDate)) {
      return lng?.today ?? 'Today';
    } else {
      return format(localDate, 'iii, MMM d', { locale });
    }
  } else {
    const utcDate = toZonedTime(Number(label), 'UTC');

    if (isToday(utcDate)) {
      return lng?.today ?? 'Today';
    } else {
      return formatInTimeZone(Number(label), 'UTC', 'iii, MMM d', { locale });
    }
  }
};
